import { render, staticRenderFns } from "./ListPackagePage.vue?vue&type=template&id=2aa5a696"
import script from "./ListPackagePage.vue?vue&type=script&lang=js"
export * from "./ListPackagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports